/*
 * OWL - Menu "MAS" (overflow) por CLICK en vez de hover.
 * El tema abre el overflow al pasar el cursor (pointerenter), lo que dejaba el panel
 * "pegado" al mover el mouse o al abrir/cerrar el carrito (quedaba en estado MAS aunque
 * ya no hiciera falta). Aqui lo controlamos por CLICK: click en MAS abre/cierra; click
 * fuera, Escape o cualquier cambio de layout (abrir/cerrar carrito, resize) lo cierran.
 * La visibilidad la da la clase .owl-mas-open en <header-component> (ver CSS del block
 * _header-menu.liquid, que anula la apertura por hover).
 */
(() => {
  const header = () => document.querySelector('header-component');
  const overflow = () => document.querySelector('overflow-list, .overflow-menu');
  const hasOverflow = () => !!overflow()?.querySelector('[slot="overflow"]');

  let openedAt = 0;
  const isOpen = () => header()?.classList.contains('owl-mas-open');
  const close = () => header()?.classList.remove('owl-mas-open');
  const open = () => {
    if (!hasOverflow()) return;
    const h = header();
    if (!h) return;
    openedAt = Date.now();
    // Anclar Anime/Tiendas JUSTO DESPUES del ultimo item visible del menu (p.ej. GORRAS),
    // para que ocupen el lugar de "MAS". El <li slot='more'> es display:contents (rect 0),
    // asi que medimos el borde derecho del ultimo item visible (que si tiene caja).
    const ov = overflow();
    const gap = 24;
    let anchorX = null;
    if (ov) {
      const visible = [...ov.querySelectorAll('.menu-list__list-item')].filter((li) => {
        const s = li.getAttribute('slot');
        return s !== 'overflow' && s !== 'more';
      });
      const last = visible[visible.length - 1];
      const link = last && (last.querySelector('.menu-list__link') || last);
      if (link) {
        const r = link.getBoundingClientRect();
        if (r.width > 0) anchorX = Math.round(r.right + gap);
      }
      // Fallback: el boton "MAS" mismo.
      if (anchorX == null) {
        const masBtn = ov.querySelector('[slot="more"] .menu-list__link, [slot="more"] button');
        if (masBtn) {
          const r = masBtn.getBoundingClientRect();
          if (r.width > 0) anchorX = Math.round(r.left);
        }
      }
    }
    if (anchorX != null) h.style.setProperty('--owl-mas-left', anchorX + 'px');
    h.classList.add('owl-mas-open');
  };

  // Click en MAS -> alterna. En captura para adelantarse al handler del componente.
  document.addEventListener(
    'click',
    (e) => {
      const target = /** @type {Element} */ (e.target);
      if (target?.closest?.('[slot="more"]')) {
        e.preventDefault();
        e.stopPropagation();
        isOpen() ? close() : open();
        return;
      }
      // Click fuera del menu de overflow -> cerrar.
      if (isOpen() && !target?.closest?.('overflow-list')) close();
    },
    true
  );

  // Escape cierra.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) close();
  });

  // Forzar el recalculo del componente overflow-list. Escucha un evento 'reflow'
  // (ver overflow-list.js: this.addEventListener('reflow', ...)). Su ResizeObserver
  // interno a veces mide DURANTE la animacion del carrito y deja "MAS" pegado; con esto
  // recalculamos cuando el layout ya se estabilizo -> MAS aparece/desaparece fiable.
  const forceReflow = () => {
    const ov = overflow();
    if (ov) ov.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
  };

  // Cualquier cambio de layout (resize, o el carrito que cambia el ancho por el
  // scroll-lock): cerrar el panel y forzar reflow (con un segundo pase por si el
  // primero cayo en mitad de la animacion).
  let rt;
  const onLayoutChange = () => {
    clearTimeout(rt);
    rt = setTimeout(() => {
      if (Date.now() - openedAt >= 400) close();
      forceReflow();
      setTimeout(forceReflow, 260);
    }, 120);
  };
  window.addEventListener('resize', onLayoutChange);
  // Captura cambios de ancho que no disparan 'resize' (p.ej. el scroll-lock del carrito).
  try {
    new ResizeObserver(onLayoutChange).observe(document.documentElement);
  } catch (e) {
    /* ResizeObserver no disponible: el resize de window cubre lo esencial. */
  }

  // Si el componente re-asigna items (slot) -> solo cerrar el panel (NO forzar reflow
  // aqui, para no crear un bucle reflow -> slot -> reflow).
  const ov = overflow();
  if (ov) {
    new MutationObserver(() => {
      if (Date.now() - openedAt >= 400) close();
    }).observe(ov, { attributes: true, attributeFilter: ['slot'], subtree: true });
  }

  // CARRITO: abrir/cerrar el drawer NO cambia el ancho del documento (es un overlay),
  // asi que el ResizeObserver de arriba no dispara. Pero al abrirlo/cerrarlo el layout
  // del header SI cambia lo suficiente para que "MAS" aparezca/desaparezca, y el
  // overflow-list a veces mide en mitad de la animacion y queda stale. Recalculamos
  // explicitamente: en el click del trigger del carrito (abrir) y en el evento 'close'
  // del <dialog> (cerrar; 'close' NO burbujea -> se escucha en captura). Doble pase
  // (tras la animacion) para asegurar el estado final.
  const scheduleReflow = () => {
    close();
    setTimeout(forceReflow, 200);
    setTimeout(forceReflow, 520);
  };
  document.addEventListener(
    'click',
    (e) => {
      if (e.target?.closest?.('[aria-controls="cart-drawer"], .header-actions__cart-icon, cart-icon')) {
        scheduleReflow();
      }
    },
    true
  );
  document.addEventListener('close', scheduleReflow, true);
})();
